export default "__VITE_ASSET__CBVyv21P__"